<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <livestock-farms-form
      :id="id"
      :title="title"
      :item="item"></livestock-farms-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
